/* Cart lines get the printed side, like every card in the shop.
   The swap only ever moves to the very next image, and only when that image carries the
   same alt text, which is the colour. So the picture always stays the colour the shopper
   actually bought: if the next image is another colour, nothing is swapped. */
(function () {
  if (window.__gtcBack) return;
  window.__gtcBack = 1;
  var jobs = {};

  function product(handle) {
    if (!jobs[handle]) {
      jobs[handle] = fetch('/products/' + handle + '.js')
        .then(function (r) { return r.json(); })
        .catch(function () { return null; });
    }
    return jobs[handle];
  }
  function file(u) { return String(u || '').split('?')[0].split('/').pop(); }

  function swap() {
    document.querySelectorAll('#cart-drawer .cart-items__table tbody tr').forEach(function (tr) {
      var img = tr.querySelector('.cart-items__media-image');
      var a = tr.querySelector('a[href*="/products/"]');
      if (!img || !a || img.dataset.gtcBack) return;
      img.dataset.gtcBack = '1';
      var handle = a.getAttribute('href').split('/products/')[1].split(/[?#]/)[0];
      product(handle).then(function (p) {
        if (!p || !p.media || !p.media.length) return;
        var cur = file(img.currentSrc || img.src);
        var i = -1;
        p.media.forEach(function (m, n) { if (file(m.src) === cur) i = n; });
        if (i < 0) return;
        var here = p.media[i], next = p.media[i + 1];
        if (!next || !here.alt || !next.alt || here.alt !== next.alt) return;
        img.removeAttribute('srcset');
        img.removeAttribute('sizes');
        img.src = next.src + (next.src.indexOf('?') > -1 ? '&' : '?') + 'width=400';
      });
    });
  }

  document.addEventListener('gtc:decorate', swap);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', swap);
  else swap();
})();
